import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ui-text-underline',
  standalone: false,
  templateUrl: './underline.component.html',
  styleUrls: ['./underline.component.scss']
})
export class UnderlineComponent implements OnInit {

  @Input() content : any;
  @Input() classList : any;
  constructor() { }

  ngOnInit(): void {
  }

}
